<template>
  <div
    :class="$style.progress"
    :style="{ gridTemplateColumns: `repeat(${totalSteps}, 1fr)` }"
  >
    <div
      v-for="step in totalSteps"
      :key="step"
      :class="[$style.segment, { [$style.active]: step <= currentStep }]"
    />
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      default: 4,
    },
  },
};
</script>

<style lang="scss" module>
.progress {
  display: grid;
  gap: 0.25rem;
  padding: 0 1.5rem;
}

.segment {
  height: 0.125rem;
  border-radius: 999px;
  background-color: $bg-primary;
  transition: background-color 0.2s ease;

  &.active {
    background-color: $green;
  }
}
</style>
